import script from "./CompanyServiceEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyServiceEditView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyServiceEditView.vue?vue&type=style&index=0&id=2a4540ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a4540ae"]])

export default __exports__